export default "__VITE_ASSET__DTDVNTO___"